import queryString from 'query-string';

export function getQueryValue(param) {
  return getQueryValueFromString(window.location.search, param);
}

export function getQueryParamsAsObj() {
  return queryString.parse(window.location.search);
}

export function getQueryParamsAsObjConvertTypes() {
  const raw = getQueryParamsAsObj();
  const keys = Object.keys(raw);
  const result = {};
  keys.forEach(k => {
    const rawVal = raw[k];
    const asFloat = parseFloat(rawVal);

    const asInt = parseInt(rawVal, 10);
    const asBool = rawVal === 'true' ? true : rawVal === 'false' ? false : null;
    const isNull = rawVal === 'null';
    const isUndefined = rawVal === 'undefined';

    if (!isNaN(asFloat)) {
      result[k] = asFloat;
    } else if (!isNaN(asInt)) {
      result[k] = asInt;
    } else if (asBool !== null) {
      result[k] = asBool;
    } else if (isNull) {
      result[k] = null;
    } else if (isUndefined) {
      result[k] = undefined;
    } else {
      result[k] = rawVal;
    }
  });

  return result;
}

export function getQueryValueFromString(search, param) {
  return queryString.parse(search)[param];
}

export function reloadWithParams(params) {
  const paramStr = encodeParams(params);
  window.location.href = `${window.location.pathname}?${paramStr}`;
}

export function encodeParams(params) {
  return queryString.stringify(params);
}

export function appendOrUpdateParams(url, params) {
  if (params) {
    const [base, search] = url.split('?');
    const initialParams = queryString.parse(search);
    const finalParams = { ...initialParams, ...params };

    const paramStr = encodeParams(finalParams);
    if (paramStr) {
      return `${base}?${paramStr}`;
    }
    return base;
  }
  return url;
}

// IE11 doesn't have window.location.origin
// https://tosbourn.com/a-fix-for-window-location-origin-in-internet-explorer/
export function getOrigin() {
  return (
    window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '')
  );
}

export function getOriginWithoutProtocol() {
  return (
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '')
  );
}

export function openUrl(url) {
  const win = window.open(url, '_blank');
  win.opener = null;
  return win;
}

// From fraction
export function getDomain(host) {
  if (host.length === 0) {
    return '';
  }
  const hostParts = host.split('.').reverse();
  if (hostParts.length >= 3) {
    let tldReg = /^(com|edu|gov|net|mil|org|nom|co|name|info|biz|uk|is|ca)$/i;
    if (hostParts[1].match(tldReg) && hostParts[0].match(tldReg)) {
      return `${hostParts[2]}.${hostParts[1]}.${hostParts[0]}`;
    }
  }
  return `${hostParts[1]}.${hostParts[0]}`;
}
